module.exports = __webpack_public_path__ + "static/media/TotalXp.d27aaf30.svg";